<template>
  <div>
    <hr />
    <h3>{{ "cancel_order" | setText("Отмена заказа") }}</h3>
    <external-informator
      :partner="partner"
      title="Причина отмены"
      titleKey="reason_cancel"
      valueKey="id"
      labelKey="message"
      v-model="data.reason_id"
      :link="'catalog/cancel/types'"
    />

    <div class="install-control">
      <button @click="send" class="btn btn-danger">
        {{ "cancel_order" | setText("Отменить заказ") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger, errorNotify } from "../../../plugins/functions";

export default {
  components: {},
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    transaction: {
      default: function () {
        return null;
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    updateOrder: {
      default: function () {},
    },
    value: {
      default: function () {},
    },
    createTransaction: {
      default: function () {},
    },
  },
  name: "filter",
  async created() {},
  methods: {
    send() {
      let data = {
        reason_id: this.data.reason_id,
        message: "",
        app_id: this.transaction.exchange_id,
      };
      this.$loading(true);
      this.$http({
        url: `${this.partner["endpoint_url"]}contract/cancel`,
        method: "POST",
        data: data,
        headers: {
          Authorization: `${
            this.partner["type_auth"] ? this.partner["type_auth"] + " " : ""
          }${this.partner["api_secret_key"]}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (response.data) {
            this.createTransaction({
              client_confirmed: 0,
              system_confirmed: 0,
              status: -1,
            });
            this.$emit("setStep", null);
            this.$emit("input", response.data);
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$emit("setStep", "client-create");
          }
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 500);
        });
    },
  },
  data() {
    return {
      data: {
        reason_id: null,
      },
    };
  },
};
</script>

